import React, { FC, ReactElement, useState, } from "react";

import { rollD10, } from ".";
import { Button, ButtonColor, ButtonStyle, classNames, Modal, ModalType, } from "components/FormControls";

type Props = {
    dice: number[];
    onCancel(): void;
    onReroll(pool: number[]): void;
};

export const RerollModal:FC<Props> = (props: Props): ReactElement => {
    const { dice, onCancel, onReroll, } = props;
    const [rerollDice, setRerollDice] = useState(initializeSelectedDice(dice.length));

    const maxRerollDice = 3;
    const count = rerollDice.filter(num => num !== undefined).length;

    const handleReroll = () => {
        // merge the old results with the new ones
        // don't forget to order them DESC
        const mergedDice = rerollDice.map((die, index) => {
            return die === undefined ? dice[index] : die;
        }).sort((a, b) => b - a);
        onReroll(mergedDice);
    };

    return (
        <Modal
            title="Reroll"
            type={ModalType.Confirm}
            onCancel={onCancel}
            onConfirm={handleReroll}
            confirmLabel={"Reroll"}
            confirmDisabled={count === 0}
        >
            <div className="__rerollmodal__">
                <p>Select up to three dice for rerolling.</p>

                <ul className="__rerollbuttons__">
                    {dice.map((num, index) => {
                        const localDice = [...rerollDice];
                        const isSelected = localDice[index] !== undefined;
                        const rerollCount = localDice.filter(num => num !== undefined).length;

                        const handleClick = () => {
                            if (isSelected) {
                                localDice[index] = undefined;
                            } else {
                                // track the number of dice selected for rerolling
                                if (rerollCount < maxRerollDice) {
                                    // we're good, re-roll the die
                                    localDice[index] = rollD10();
                                }
                            }

                            // update state with the new results
                            setRerollDice(localDice);
                        };

                        const css = classNames([
                            "__rerollbutton__",
                            isSelected ? "selected active" : "",
                        ]);

                        const style = isSelected ? undefined : ButtonStyle.Outline;
                        const isDisabled = isSelected ? false : (rerollCount >= maxRerollDice);
                        const color = isDisabled ? ButtonColor.Secondary : undefined;

                        return (
                            <li key={index}>
                                <Button
                                    className={css}
                                    onClick={handleClick}
                                    color={color}
                                    style={style}
                                    disabled={isDisabled}
                                >
                                    <strong>{num}</strong>
                                </Button>
                            </li>
                        );
                    })}
                </ul>
            </div>
        </Modal>
    );
};

// return a undefined-filled array of n length
const initializeSelectedDice = (n: number): (number | undefined)[] => {
    return Array(n).fill(undefined);
};

